import { apiCallWrapper, IdNameModel, SelectOptionModel } from 'traveldesk-ui'
import Offer from '../models/Offer'
export default class OffersApiService {
    static save = async (dispatch: any, model: Offer) => {
        return await apiCallWrapper<Offer>('/api/offers', model.id == 0 ? 'POST' : 'PUT', dispatch, model)
    }
    static getOfferForEdit = async (dispatch: any, id: number) => {
        return await apiCallWrapper<Offer>(`/api/offers/manage/${id}`, 'GET', dispatch)
    }
    static getOfferTranslation = async (dispatch: any, id: number, languageId: number) => {
        return await apiCallWrapper<Offer>(`/api/offers/translation/${id}?languageId=${languageId}`, 'GET', dispatch)
    }
    static getOfferTranslatedTo = async (dispatch: any, id: number) => {
        return await apiCallWrapper<SelectOptionModel[]>(`/api/offers/translatedto/${id}`, 'GET', dispatch)
    }
    static translateOffer = async (dispatch: any, id: number, toLanguage: number) => {
        return await apiCallWrapper<any>(`/api/offers/translate/${id}?toLanguage=${toLanguage}`, 'GET', dispatch)
    }
    static setPublished = async (dispatch: any, offerId: number, isPublished: boolean) => {
        return await apiCallWrapper<boolean>('/api/offers/publish', 'POST', dispatch, { offerId, isPublished })
    }
    static getOptions = async (dispatch: any) => {
        return await apiCallWrapper<IdNameModel[]>('/api/offers/options', 'GET', dispatch)
    }
}
